import React from 'react'
import Layout from '../components/Layout'
import { Link } from "react-router-dom";
import {ArrowLeftIcon} from '@heroicons/react/20/solid'

const NotFoundPage = () => {
  return (
    <Layout title='Page Not Found'>
    <div className="w-full py-40 text-center">
            <h1 className="px-4 mx-auto font-mono text-2xl font-extrabold text-gray-900 dark:text-white lg:text-4xl">
            Whoops 
                <span className="text-gradient from-purple-600 to-pink-600">
                 404
                </span>
            </h1>
            <Link
                to="/"
                className="inline-block mt-12 text-gray-700 dark:text-white hover:underline underline-offset-8"
            >
                <ArrowLeftIcon className="inline-block w-5 h-5 mr-2 -mt-1" />
                Go Home
            </Link>
        </div>
    </Layout>
  )
}

export default NotFoundPage